// extracted by mini-css-extract-plugin
export default {"icon":"status-indicator_icon__M0DxQ","opacity-transition":"status-indicator_opacity-transition__q3Oqm"};